import React from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

import styles from './styles.module.scss';

export interface IBlockTop {
  title: string;
  subtitle: string;
  customComponent?: Nullable<JSX.Element | JSX.Element[]>;
}

interface IBlockMiddleEmpty {
  content: string;
  externalClasses?: string;
}

interface IBlockBottom {
  link: string;
  text: string;
}

export const BlockTop = ({ title, subtitle, customComponent }: IBlockTop) => (
  <div
    className={classnames(styles.wrapper, styles.top)}
    data-testid="widget-block-top"
  >
    <div className={styles.title}>{title}</div>
    <div className={styles.subtitle}>{subtitle}</div>
    {customComponent}
  </div>
);

export const BlockMiddleEmpty = ({
  content,
  externalClasses,
}: IBlockMiddleEmpty) => (
  <div
    className={classnames(
      styles.wrapper,
      styles.middle,
      styles.empty,
      externalClasses,
    )}
  >
    <p>{content}</p>
  </div>
);

export const BlockMiddleTable = (props: {
  children: JSX.Element | JSX.Element[];
  testId?: string;
}) => (
  <div
    className={classnames(styles.wrapper, styles.middle, styles['not-empty'])}
    data-testid={props.testId}
  >
    {props.children}
  </div>
);

export const BlockBottom = ({ link, text }: IBlockBottom) => (
  <div className={classnames(styles.wrapper, styles.bottom)}>
    <Link to={link}>{text}</Link>
  </div>
);
